module.exports = __webpack_public_path__ + "static/img/appointmenttop.a3165e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appointmenttop.jpg
// module id = OgTN
// module chunks = 0